<template>
  <b-form-select v-model="selectedColor" size="sm" placeholder="Selecione a cor" class="w-100">
    <b-form-select-option
      v-for="color in colors"
      :key="color.value"
      :value="color.value"
    >
      {{ color.text }}
    </b-form-select-option>
  </b-form-select>
</template>

<script>
export default {
  name: 'ColorSelect',
  props: {
    value: {
      type: String,
    },
    isFilter: {
      type: Boolean,
      default: false
    },
    valueDefault: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedColor: this.value || this.valueDefault
    };
  },
  computed: {
    colors() {
      const baseColors = [
        { value: 'lightblue', text: 'Azul claro' },
        { value: 'blue', text: 'Azul escuro' },
        { value: 'lightgray', text: 'Cinza claro' },
        { value: 'gray', text: 'Cinza escuro' },
        { value: 'yellow', text: 'Amarela' },
        { value: 'orange', text: 'Laranja' },
        { value: 'green', text: 'Verde' },
        { value: 'red', text: 'Vermelha' },
        { value: 'brown', text: 'Marrom' },
        { value: 'pink', text: 'Rosa claro' },
        { value: 'darkpink', text: 'Rosa escuro' },
        { value: 'purple', text: 'Roxo' },
      ];
      
      if (this.isFilter) {
        return [{ value: '', text: 'Todas as cores' }, ...baseColors];
      }
      return baseColors;
    }
  },
  watch: {
    value(newValue) {
      if(!newValue) {
        newValue = this.valueDefault;
      }

      this.selectedColor = newValue;
    },
    selectedColor(newValue) {
      this.$emit("input", newValue);
    }
  }
}
</script>
